/* global document, ga, hj, window, Modernizr */

export default {
  store: {
    state: {
      downloadCounter: 0,
      boardMenu: [
        // ['RouteName', 'icon', 'class', 'Name', 'isExact', 'isInMobileTop'],
        ['Overview', 'radio', 'white', 'Overview', true],
        ['Board', 'calendar', 'white', 'Board', true, true],
        ['Clients', 'user', 'purple', 'Clients', false, true],
        ['Vehicles', 'car', 'red', 'Vehicles', false, true],
        ['Jobcards', 'tasks', 'blue', 'Jobcards', false, true],
        ['Invoices', 'invoice', 'green', 'Invoices', false, true],
        ['Expenses', 'expense', 'red', 'Expenses', false, true],
        ['Team', 'users', 'orange', 'Team', false],
        ['Profile', 'user', 'yellow', 'Profile', false],
      ],
      screenSizes: ['xs'],
      url: null,
      visited: [],
    },
    actions: {
      CHECK_SCREEN_SIZE({ commit }) {
        const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
        commit('SET_SCREEN_SIZES', [
          ['xs', 0],
          ['sm', 576],
          ['md', 768],
          ['lg', 992],
          ['xl', 1200],
        ].filter(([_, minWidth]) => width > minWidth)
          .map(([size, _]) => size))
      },
      PAGEVIEW({ commit, getters }, { to, from }) {
        commit('SET_URL', to.path)
        commit('ADD_VISITED', to.path)

        // interface in the future
        if (!getters.isAdmin && from.name !== null) {
          const stats = {
            ga: path => ga('send', 'pageview', path),
            hj: path => hj('stateChange', path),
          }

          Object.keys(stats)
            .filter(key => window[key])
            .forEach((key) => {
              stats[key](to.path)
            })
        }
      },
      // GEVENT({ commit, getters }, { category, action = 'Click', label } = {}) {
      //   if (!getters.isAdmin) {
      //     ga('send', 'event', category, action, label)
      //   }
      // },
      ON(_, events) {
        Object.keys(events).forEach((eventName) => {
          const passiveEvents = ['mousewheel']

          const options =
            Modernizr.passiveeventlisteners && passiveEvents.includes(eventName)
              ? { passive: true }
              : false

          window.addEventListener(eventName, events[eventName], options)
        })
      },
      OFF(_, events) {
        Object.keys(events).forEach((eventName) => {
          window.removeEventListener(eventName, events[eventName])
        })
      },
      GO_BACK({ state }, { $router, fallback = 'Index' }) {
        if (state.visited.length > 1 && state.visited[0] !== state.url) {
          $router.go(-1)
        } else {
          $router.push({ name: fallback })
        }
      },
      DOWNLOAD({ commit, state }, url) {
        // window.location.assign(url)
        const iframe = document.createElement('iframe')
        iframe.id = `downloader${state.downloadCounter}`
        iframe.style.display = 'none'
        document.body.appendChild(iframe)
        iframe.src = url
        commit('INC_DOWNLOAD')
      },
    },
    mutations: {
      ADD_VISITED(state, path) {
        state.visited.push(path)
      },
      SET_URL(state, path) {
        state.url = path
      },
      SET_SCREEN_SIZES(state, screenSizes) {
        state.screenSizes = screenSizes
      },
      INC_DOWNLOAD(state) {
        state.downloadCounter += 1
      },
    },
    getters: {
      isDesktop: (_, getters) => getters.screenSizes.includes('md'),
      boardMenu: state => state.boardMenu,
      url: state => state.url,
      screenSizes: state => state.screenSizes,
      visited: state => state.visited,
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/navigation.js